import Database from "../database/Database";
import Sweetalert from "../../components/sweetalert/Sweetalert";

const carts = {
  description: "",
  paymethod_id: false,
  shipping: false,
  address_id: "",
  items: {},
};

const Carts = {
  getCartItems(carts) {
    if (carts?.items) {
      return Object.keys(carts?.items).length ? Object.keys(carts?.items) : [];
    }

    return [];
  },

  setCart(cart, setCart) {
    var newData;

    if (cart) {
      newData = cart;
    } else {
      newData = carts;
    }

    setCart(newData);

    Database.set("carts", JSON.stringify(newData));
  },
  changed(carts, data, value, setData) {
    var newData = {
      ...carts,
      [data]: value,
    };

    setData(newData);

    Database.set("carts", JSON.stringify(newData));
  },
  changedItems(carts, data, quantity, setData) {
    var newData;

    if (quantity <= 0) {
      newData = Object.assign({}, carts);

      delete newData?.items[data.id];
    } else {
      data["product_id"] = data?.id;
      data["count"] = quantity;

      newData = {
        ...carts,
        items: {
          ...carts?.items,
          [data.id]: data,
        },
      };
    }

    setData(newData);

    Database.set("carts", JSON.stringify(newData));
  },
  remove(key, carts, setData) {
    var swl = {
      title: "",
      text: "آیا مایل به حذف این غذا هستید؟",
      icon: "warning",
      confirmButtonText: "بله، حذف شود !",
      cancelButtonText: "خیر",
      confirmed: true,
      confirmedTitle: "حذف شد!",
      confirmedText: "غذا انتخاب شده از سبد خرید حذف شد.",
      confirmedIcon: "success",
      confirmedButtonText: "حله!",
      confirmedCallBack: this.onRemove.bind(this),
    };

    Sweetalert.confirm(swl, { key, carts, setData });
  },
  onRemove(data) {
    if (data.carts) {
      const carts = Object.assign({}, data.carts);

      delete carts?.items?.[data.key];

      data.setData(carts);

      Database.set("carts", JSON.stringify(carts));
    }
  },
  getCart() {
    if (Database.get("carts")) {
      return JSON.parse(Database.get("carts"));
    } else {
      return false;
    }
  },
  getCartLength(carts) {
    var count = 0;

    if (carts?.items) {
      for (var i = 0; i < this.getCartItems(carts).length; i++) {
        count = count + carts?.items[this.getCartItems(carts)[i]]?.count;
      }
    }

    return count;
  },
  getProductQuantity(carts, productId) {
    if (carts?.items) {
      if (carts?.items[productId]) {
        return carts?.items[productId].count;
      }
    }

    return 0;
  },
  getCartPrice(carts) {
    var price = 0; // قیمت غذا ها
    var packing_price = 0; // هزینه بسته بندی
    var offer = 0; // تخفیف
    var payable = 0; // جمع کل

    var productCount = 0;

    this.getCartItems(carts).forEach((cart) => {
      productCount = carts?.items[cart]?.count;

      if (carts?.items[cart]?.price) {
        price = price + carts?.items[cart]?.price * productCount;
      }

      if (carts?.items[cart]?.offer) {
        offer = offer + carts?.items[cart]?.offer * productCount;
      }

      if (carts?.items[cart]?.payable) {
        payable = payable + carts?.items[cart]?.payable * productCount;
      }
    });

    // if (carts?.shipping?.id) {
    //   payable = payable + carts?.shipping?.price + packing_price;
    // }

    return { price, packing_price, offer, payable };
  },
};

export default Carts;
